// extracted by mini-css-extract-plugin
export const description = "CruiseSuiteCard-module--description--3NtH3";
export const footer = "CruiseSuiteCard-module--footer--2f9GD";